import React from 'react';

const FileUpload = ({ uploadFile, setUploadFile, errorMessage, setErrorMessage }) => {
    const handleFileUpload = (file) => {
        const allowedTypes = ['text/plain', 'text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
        if (file && allowedTypes.includes(file.type)) {
            setUploadFile(file);
            setErrorMessage('');
        } else {
            setErrorMessage('Invalid file type. Only .txt, .csv, or .xlsx files are allowed.');
        }
    };

    const handleInputChange = (e) => {
        const file = e.target.files[0];
        if (file) handleFileUpload(file);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        if (file) handleFileUpload(file);
    };

    return (
        <div style={styles.wrapper}>
            <label style={styles.label}>Upload File</label>
            <div
                style={{ ...styles.dropZone, ...(uploadFile ? styles.dropZoneSuccess : {}), ...(errorMessage ? styles.dropZoneError : {}) }}
                onDrop={handleDrop}
                onDragOver={(e) => e.preventDefault()}
            >
                <input
                    type="file"
                    id="fileUpload"
                    accept=".txt,.csv,.xlsx"
                    onChange={handleInputChange}
                    style={{ display: 'none' }}
                />
                <label htmlFor="fileUpload" style={styles.dropLabel}>
                    {uploadFile ? (
                        <div style={styles.fileInfo}>
                            <i className="bi bi-file-earmark-check" style={{ fontSize: 24, color: '#16a34a' }}></i>
                            <span style={styles.fileName}>{uploadFile.name}</span>
                            <span style={styles.fileSize}>({(uploadFile.size / 1024).toFixed(1)} KB)</span>
                        </div>
                    ) : (
                        <div style={styles.placeholder}>
                            <i className="bi bi-cloud-upload" style={{ fontSize: 28, color: '#9ca3af' }}></i>
                            <p style={styles.placeholderText}>
                                Drag and drop a file here or <span style={styles.browseLink}>browse</span>
                            </p>
                            <p style={styles.formatText}>Supported: .txt, .csv, .xlsx</p>
                        </div>
                    )}
                </label>
            </div>
            {errorMessage && (
                <span style={styles.error}>
                    <i className="bi bi-exclamation-circle" style={{ marginRight: 5 }}></i>
                    {errorMessage}
                </span>
            )}
        </div>
    );
};

const styles = {
    wrapper: { marginBottom: '20px', display: 'flex', flexDirection: 'column', gap: '6px' },
    label: { fontSize: '13px', fontWeight: '600', color: '#374151' },
    dropZone: { border: '2px dashed #d1d5db', borderRadius: '10px', background: '#f9fafb', cursor: 'pointer', transition: 'border-color 0.2s' },
    dropZoneSuccess: { borderColor: '#16a34a', background: '#f0fdf4' },
    dropZoneError: { borderColor: '#ef4444', background: '#fef2f2' },
    dropLabel: { display: 'block', cursor: 'pointer', padding: '24px' },
    fileInfo: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' },
    fileName: { fontSize: '14px', fontWeight: '600', color: '#111827' },
    fileSize: { fontSize: '12px', color: '#6b7280' },
    placeholder: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px' },
    placeholderText: { fontSize: '14px', color: '#6b7280', margin: 0, textAlign: 'center' },
    browseLink: { color: '#1565c0', fontWeight: '600' },
    formatText: { fontSize: '12px', color: '#9ca3af', margin: 0 },
    error: { fontSize: '12px', color: '#ef4444', display: 'flex', alignItems: 'center' },
};

export default FileUpload;
